const zh = {
  name: '名称',
  category: '类目',
  addProduct: '新增商品',
  addOrEditProduct: '新增/修改商品',
  addOrEditCategoryProduct: '新增/修改类目商品',
  editCategoryInfo: '修改商品类目信息',
  plCode: '请输入分类编码',
  plName: '请输入分类名称',
  selCategory: '请选择商品类目',
  code: '编码',
  addCategory: '新增类目',
  addSubCategory: '新增子类目',
  noDelTips1: '该类目下有产品，无法进行删除。',
  tips: '提示',
  conTips: '确定删除该类目吗？',
  noDelTips2: '该类目下有子类目，无法进行删除。',
  plEnterName: '请输入类目名称',
  productList: '商品列表',
  delCategory: '删除类目',
  plSearch:'请输入关键字搜索',
  fetchFail: '商品类目查询失败',

  storeType: '库存类型：',
  storeTypeCloumn:'库存类型',
  storeTypeNum: '数量',
  storeTypeCode: '条码',
  hsCode: 'HS编码',
  plHsCode: '请输入HS编码',
  plChooseType: '请选择类型',
  all: '全部',
  setCategoryOrg: '设置类目分管部门'
};

export default zh;